export default __webpack_public_path__ + "./images/bf.2195645e.png";